module.exports = __webpack_public_path__ + "img/02_Datos - ICONO.0035cfd0.png";